import { Trash2, Sparkles } from "lucide-react";
import {
  useHostVolumes,
  useDeleteVolume,
  usePruneVolumes,
} from "@/hooks/useDocker";

export function VolumesPanel({ hostId }: { hostId: number }) {
  const { data: volumes, isLoading } = useHostVolumes(hostId);
  const del = useDeleteVolume(hostId);
  const prune = usePruneVolumes(hostId);

  return (
    <section className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <h2 className="text-lg font-semibold text-gray-200">Volumes</h2>
        <button
          onClick={() => {
            if (window.confirm("Supprimer tous les volumes non utilisés ?"))
              prune.mutate();
          }}
          className="inline-flex items-center gap-1 rounded border border-gray-700 px-3 py-1 text-sm text-gray-300 hover:bg-gray-800"
        >
          <Sparkles className="h-3.5 w-3.5" />
          Prune
        </button>
      </div>

      <div className="overflow-hidden rounded-lg border border-gray-800">
        <table className="min-w-full divide-y divide-gray-800 text-sm">
          <thead className="bg-gray-900/60 text-left text-gray-400">
            <tr>
              <th className="px-4 py-2">Nom</th>
              <th className="px-4 py-2">Driver</th>
              <th className="px-4 py-2">Utilisé</th>
              <th className="px-4 py-2 text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800">
            {(volumes ?? []).map((v) => (
              <tr key={v.name}>
                <td className="max-w-md truncate px-4 py-2 font-mono text-gray-100">
                  {v.name}
                </td>
                <td className="px-4 py-2 text-gray-400">{v.driver}</td>
                <td className="px-4 py-2">
                  {v.in_use ? (
                    <span className="rounded bg-green-900/40 px-2 py-0.5 text-xs text-green-300">
                      monté
                    </span>
                  ) : (
                    <span className="text-xs text-gray-500">orphelin</span>
                  )}
                </td>
                <td className="px-4 py-2 text-right">
                  <button
                    title="Supprimer le volume"
                    onClick={() => {
                      if (
                        window.confirm(
                          v.in_use
                            ? "Volume monté — forcer la suppression ? (perte de données)"
                            : `Supprimer le volume ${v.name} ?`,
                        )
                      )
                        del.mutate({ name: v.name, force: v.in_use });
                    }}
                    className="rounded p-1 text-gray-400 hover:bg-red-900/40 hover:text-red-300"
                  >
                    <Trash2 className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
            {!isLoading && volumes && volumes.length === 0 && (
              <tr>
                <td colSpan={4} className="px-4 py-3 text-gray-500">
                  Aucun volume.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
